<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer003">
<p class="Praise-Heading"><span class="Bold CharOverride-1">Praise for <br/></span><span class="Italic CharOverride-2">Sustainable Badass</span></p>
<p class="Praise-Quote">“Gittemarie is a one-of-a-kind creator and a much-needed voice in the movement. Her attention to detail and level of research is a true testament not only to the quality of her work, but to the intensity with which she takes on the waste crisis. A much-respected and positi<span class="noBreak">ve</span><span class="noBreak"> </span><span class="noBreak">force!”</span></p>
<p class="Praise-Author">—Immy Lucas (@Sustaina<span class="noBreak">bly_Vegan)</span></p>
<p class="Praise-Quote">“Gittemarie is creator that not only provides helpful tips on living a zero-waste and vegan lifestyle, but also articulates it in way that is<span class="noBreak"> </span>appr<span class="noBreak">oachable.”</span></p>
<p class="Praise-Author">—Jhánneu Roberts <span class="noBreak">(@Jhanneu)</span></p>
<p class="Praise-Quote">“Gittemarie provides extensive amounts of accessible eco-friendly tips and education for those entering a sustainability lifestyle. With themed recipes and fun humor, Gittemarie is paving the way for sustainable<span class="noBreak"> </span><span class="noBreak">futures.”</span></p>
<p class="Praise-Author">—Isaias Hernandez (@QueerB<span class="noBreak">rownVegan)</span></p>
<p class="Praise-Quote">“<span class="Italic _idGenCharOverride-1">Sustainable Badass </span>is enlightening and entertaining! It’ll have you reaching for your reusable bags and turning that eco-guilt int<span class="noBreak">o</span><span class="noBreak"> </span><span class="noBreak">action.”</span></p>
<p class="Praise-Author">—Kathryn Kellogg, author of <span class="Bold-Italic _idGenCharOverride-1">101 Ways to Go Zero Waste</span><span class="Italic _idGenCharOverride-1"> </span>(@going.z<span class="noBreak">ero.waste)</span></p>
<p class="Praise-Quote">“Gittemarie has been an inspiration to me for years! She’s always prepared to address a given environmental concern with an educated perspective and provide solutions to her audience. Not to mention her style, which makes her my personal favorite eco-fas<span class="noBreak">hionista.”</span></p>
<p class="Praise-Author">—Shelbi Orme (@sh<span class="noBreak">elbizleee)</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SustainableBadass.vue?401de05c